/**
 * Liberacao nominal da segregacao de funcoes (ADR 0091).
 *
 * Quem criou, carregou ou editou o rascunho nao o ativa, salvo a pessoa que o dono
 * liberou nominalmente. O servidor diz as duas coisas na resposta: a autoria
 * (`authored_by_you` ou `draft_authored_by_you`) e a liberacao (`may_self_approve` ou
 * `draft_may_self_approve`, so verdadeira junto com a autoria). A tela liga o botao com
 * o aviso de autoaprovacao; quem decide continua sendo o servidor, na ativacao.
 */

export const AVISO_AUTOAPROVACAO =
  'Voce criou ou editou este rascunho, e a sua conta esta liberada para ativa-lo mesmo assim. ' +
  'A ativacao fica registrada como autoaprovacao na trilha.';

/** Autoria do rascunho vista pela tela. */
export interface Autoria {
  /** Quem pede e autor e nao tem a liberacao: o botao fica desligado. */
  barrada: boolean;
  /** Quem pede e autor e tem a liberacao: o botao liga, com o aviso. */
  autoaprovacao: boolean;
}

/** Le a autoria e a liberacao que o servidor mandou. */
export function autoriaDe(
  autor: boolean | undefined,
  podeAutoaprovar: boolean | undefined,
): Autoria {
  const ehAutor = autor === true;
  const liberado = ehAutor && podeAutoaprovar === true;
  return { barrada: ehAutor && !liberado, autoaprovacao: liberado };
}
